import AvatarComponent from "@/components/common/avatar";
import ReadMore from "@/components/common/read-more";
import CustomAntCarousel from "@/components/CustomAntCarousel";
import CustomCourseCarousel from "@/components/CustomCourseCarousel";
import useWidth from "@/helpers/widthUtil";
import { SafetyCertificateOutlined, TwitterCircleFilled, LinkedinFilled, DownloadOutlined } from '@ant-design/icons';
import { Avatar, Button, Tooltip } from 'antd';
import React from "react";
import { Col, Container, Row } from 'reactstrap';


const TutorDetailComponent = ({ data }) => {
    const { isMobile } = useWidth();
    return (
        <div className="main-wrapper instructor-details-page">
            <section className="instructor-details-area">
                <Container>
                    <Row>
                        <Col md="4">
                            {/* <div className="instructor-img"> */}
                            {/* {
                                    data?.tutor?.avatar ?
                                        <img src={data?.tutor?.avatar} alt={data?.tutor?.first_name} className="img-fluid" />
                                        :
                                        <AvatarComponent firstName={data?.tutor?.first_name} lastName={data?.tutor?.last_name} biggerAvatar={true} size={100} />
                                } */}

                            {
                                data?.tutor?.avatar ?
                                    <div className="d-flex justify-content-center">
                                        <img
                                            className="m-5"
                                            // src={"https://learnsic.com/media/public/user_avatar/2022_07_05_19_06_17_2.jpg"}
                                            src={data?.tutor?.avatar}
                                            width={isMobile ? 200 : 350}
                                        />
                                    </div>
                                    :
                                    <div className="d-flex justify-content-center">
                                        <AvatarComponent
                                            firstName={data?.tutor?.first_name}
                                            lastName={data?.tutor?.last_name}
                                            size={200}
                                            biggerAvatar={true}
                                            className='d-flex justify-content-center align-items-center text-center'
                                        />
                                    </div>
                            }
                            <div className="d-flex flex-column justify-content-between align-items-center text-center mt-3 mb-3">

                                {data?.twitter && <Button style={{ width: '8rem' }} href={data.twitter} target="_blank" size="large" className="btn-outline-danger border-danger text-center"><i className="fab fa-twitter mr-1"></i><span className="font-size-sm">Twitter</span></Button>}
                                {data?.linkedin && <Button style={{ width: '8rem' }} href={data.linkedin} target="_blank" size="large" type="text" className="btn-outline-danger border-danger text-center mt-2" ><i className="mr-1 fab fa-linkedin"></i><span className="font-size-sm">Linkedin</span></Button>}
                            </div>
                            {/* </div> */}
                        </Col>
                        <Col md="8" className="mb-30">
                            <div className="instructor-content m-2">
                                <h4 className={`text-uppercase text-muted font-size-sm ${isMobile && 'mt-3'}`}>Instructor</h4>
                                <h4 className="text-primary text-capitalize mb-5 ins-name">{data?.tutor?.first_name} {data?.tutor?.last_name}</h4>
                                <span className="text-dark"><u>About me</u></span>
                                <p className="text-justify mt-2">{data?.biography}</p>
                            </div>
                            <div className="qual-expe d-flex flex-column justify-content-between mt-4 m-2">
                                {
                                    data?.education?.length > 0 &&
                                    <div className="qualification">
                                        <h5 className="text-primary">Qualifications</h5>
                                        {
                                            data?.education?.map((data, i) => {
                                                const { id, certificate, description, start_year, end_year, institute_name, title } = data;
                                                return (
                                                    <div className="qual-expe-box" key={i}>
                                                        <h6 className="d-flex justify-content-between">
                                                            <span className="text-dark font-weight-bold"> <u >{title} ({start_year}-{end_year})</u></span>
                                                            {
                                                                certificate &&
                                                                <Tooltip placement="top" title={'View Certificate'}>
                                                                    <a target='_blank' href={certificate}>
                                                                        <SafetyCertificateOutlined className='ml-2 certificate-button' />
                                                                    </a>
                                                                </Tooltip>
                                                            }
                                                        </h6>
                                                        <p className="text-justify">{description}</p>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                }
                                {
                                    data?.experience?.length > 0 &&
                                    <div className="experiance m-2">
                                        <h5 className="text-primary">Experience</h5>
                                        {
                                            data?.experience?.map((job, index) => {
                                                var { id, certificate, company, description, end_year, start_year, title } = job;
                                                return (
                                                    <div className="qual-expe-box" key={index}>
                                                        <h6 className="d-flex justify-content-between">
                                                            <span className="text-dark font-weight-bold"> <u >{title} ({start_year}-{end_year})</u></span>
                                                            {
                                                                certificate &&
                                                                <Tooltip placement="top" title={'View Certificate'}>
                                                                    <a target='_blank' href={certificate}>
                                                                        <SafetyCertificateOutlined className='ml-2 certificate-button' />
                                                                    </a>
                                                                </Tooltip>
                                                            }
                                                        </h6>
                                                        <p>{company}</p>
                                                        <p className="text-justify">{description}</p>
                                                    </div>
                                                )

                                            })
                                        }

                                    </div>
                                }
                            </div>
                        </Col>
                        {
                            data?.tutor_courses?.length !== 0 &&
                            <Col md="12" className="mt-5">
                                <div className="instructor-course-title mx-auto d-flex">
                                    <h5 className="text-primary">My Courses</h5>
                                </div>
                                {/* <div className="instructor-course-slider"> */}
                                {/* <CustomCourseCarousel courses={data?.tutor_courses} /> */}
                                {/* </div> */}
                                <div className="row">
                                    <CustomCourseCarousel courses={data?.tutor_courses} />
                                </div>
                            </Col>
                        }
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default TutorDetailComponent;